module.exports = __webpack_public_path__ + "img/shotgun.1f9afd5f.svg";